import OutGoingWrapper from '../OutGoingWrapper'
import { connect } from 'react-redux'

function ActiveCallPopUp(props) {
  const { callPopUpStatus, currentStoreTelecomConfig, isCallActive, contact, callInfo, telecomServiceType, isCallRecordingActive, editing } = props

  return (
    <div className='calling-pop-up'>
      <div className='dailer-box calling-pop-up-wrap'>
        <OutGoingWrapper
          callPopUpStatus={callPopUpStatus}
          currentStoreTelecomConfig={currentStoreTelecomConfig}
          isCallRecordingActive={isCallRecordingActive}
          telecomServiceType={telecomServiceType}
          isCallActive={isCallActive}
          contact={contact}
          callInfo={callInfo}
          editing={editing}
          fromActiveCallPopup={true}
        />
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { voip, organisation: { organisation }, currentStore, contact } = state;

  return {
    isCallRecordingActive: voip.voip_addon.config?.voip_settings?.call_recording?.active,
    currentStoreTelecomConfig: currentStore.store?.telcom_config,
    telecomServiceType: organisation.telcom_service_type,
    callPopUpStatus: voip?.call_pop_up_status,
    isCallActive: voip?.calling_info.isCallActive,
    contact: contact.contact_list,
    callInfo: voip?.calling_info,
    editing: voip.editing
  }
}

export default connect(mapStateToProps)(ActiveCallPopUp);
